const map = document.getElementById('map')
const lat = 52.832596
const lng = 13.821226
const zoom = 17

if (map) {
    const osm = L.map('map', {
        attributionControl: false,
        gestureHandling: true,
    }).setView([lat, lng], zoom)

    L.tileLayer('https://b.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 14,
    }).addTo(osm)

    const markerIcon = L.icon({
        iconUrl: new URL("../../img/leaflet/map-marker.svg", import.meta.url),
        iconSize: [38, 48],
        iconAnchor: [19, 48],
    });

    const marker = L.marker([lat, lng], {icon: markerIcon}).addTo(osm)
}